<template>
    <main class="data-page news-page">
        <section class="page-hero compact-hero">
            <div><small>YAXUN SPORTS NEWSROOM</small><h1>体育资讯</h1><p>聚合赛前情报、专家观点、阵容变化与数据趋势</p></div>
            <div class="hero-kpis"><span><b>{{counts.all || 0}}</b>全部资讯</span><span><b>{{counts.event || 0}}</b>赛事分析</span><span><b>{{counts.expert || 0}}</b>专家研究</span></div>
        </section>
        <section class="data-panel news-panel">
            <div class="filter-tabs">
                <button v-for="tab in tabs" :key="tab.value" :class="channel===tab.value?'active':''" @click="changeChannel(tab.value)">{{tab.name}} <em>{{countFor(tab.value)}}</em></button>
                <i>独立观点 · 数据佐证 · 清晰表达</i>
            </div>
            <div class="news-grid research-news-grid" v-if="list.length">
                <router-link v-for="item in list" :key="item.id" :to="'/news/'+item.id" class="news-card research-news-card">
                    <div :class="['article-avatar', item.is_expert?'expert-avatar':'site-avatar']"><img :src="articleAvatar(item)" @error="$event.target.src=sitePlaceholder" :alt="item.is_expert?(item.author+'专家头像'):'亚讯体育'"/><i v-if="item.is_expert">认证专家</i></div>
                    <div class="news-copy"><small><b>{{item.category}}</b>{{item.source_category}} · {{item.time}}</small><h2>{{item.title}}</h2><p>{{item.summary || '从球队近况、阵容信息与比赛数据出发，给出完整的赛事研判观点。'}}</p><footer><span>{{item.author || '亚讯体育研究中心'}}</span><b>阅读全文 →</b></footer></div>
                </router-link>
            </div>
            <div class="panel-loading" v-else-if="loading"><van-skeleton row="8" title/></div>
            <div class="empty-state" v-else><b>暂无专家资讯</b><span>请稍后再来查看</span></div>
            <button class="load-more" v-if="!finished && list.length" @click="loadMore">加载更多资讯</button>
        </section>
    </main>
</template>

<script>
import sitePlaceholder from '../assets/images/yaxun-sports-logo.svg'
export default {
    name: 'news',
    data(){ return {
        sitePlaceholder,
        channel:'expert', list:[], pageIndex:1, loading:true, finished:false, counts:{},
        tabs:[{name:'专家分析',value:'expert'},{name:'全部资讯',value:'all'},{name:'赛事分析',value:'event'}]
    }},
    created(){ this.getList() },
    methods: {
        countFor(channel){ return channel==='all'?(this.counts.all||0):(channel==='event'?(this.counts.event||0):(this.counts.expert||0)) },
        articleAvatar(item){ return item.is_expert && item.portrait ? this.$api.imgBaseUrl+item.portrait : this.sitePlaceholder },
        changeChannel(channel){ if(this.channel===channel)return; this.channel=channel; this.list=[]; this.pageIndex=1; this.finished=false; this.getList() },
        loadMore(){ if(this.loading)return; this.pageIndex++; this.getList() },
        getList(){
            this.loading=true
            this.$post(this.$api.news_list,{page:this.pageIndex,pageSize:12,channel:this.channel}).then(res=>{
                if(res.code===1){ this.list=this.list.concat(res.data.news_list||[]); this.counts=res.data.counts||{}; this.finished=Boolean(res.data.end) }
                else this.finished=true
            }).catch(()=>{this.$toast.fail('资讯读取失败');this.finished=true}).finally(()=>{this.loading=false})
        }
    }
}
</script>

<style scoped></style>
